import './assets/css/vars.css'
import './assets/css/container.css'
import './assets/css/ymaps.css'
import './assets/css/reset.css'
import './assets/css/style.css'
import './assets/css/button.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
